document.addEventListener('alpine:init', () => {
  Alpine.data('bagFit', (config = {}) => ({
    loading: false,
    loaded: false,
    error: false,
    query: '',
    activeCategory: 'mobile',
    devices: [],

    catalogueUrl: config.catalogueUrl,

    searchUrl: config.searchUrl || '/search',

    bag: {
      width: Number(config.width),
      height: Number(config.height),
      depth: Number(config.depth),
    },

    labels: {
      fits: config.labels?.fits || 'Fits',
      doesntFit: config.labels?.doesntFit || "Doesn't fit",
      unknown: config.labels?.unknown || 'Fit unknown',
    },

    categories:
      Array.isArray(config.categories) && config.categories.length
        ? config.categories
        : [
            {
              id: 'mobile',
              label: 'Mobile',
            },
            {
              id: 'tablet',
              label: 'Tablet',
            },
            {
              id: 'laptop',
              label: 'Laptop',
            },
          ],

    async loadDevices() {
      if (this.loaded || this.loading) {
        return;
      }

      this.loading = true;
      this.error = false;

      try {
        const response = await fetch(this.catalogueUrl, {
          credentials: 'same-origin',
        });

        if (!response.ok) {
          throw new Error(
            `Device catalogue returned ${response.status}`
          );
        }

        const data = await response.json();

        this.devices = Array.isArray(data.devices)
          ? data.devices
          : [];

        this.loaded = true;
      } catch (error) {
        console.error(
          '[bagFit] Unable to load device catalogue',
          error
        );

        this.error = true;
      } finally {
        this.loading = false;
      }
    },


    isStoreProduct(device) {
      return device?.category === 'fairfax';
    },

    searchHref(device) {
      if (!this.isStoreProduct(device)) {
        return '';
      }

      const searchTerm =
        device.search_term ||
        device.aliases?.[0] ||
        device.name ||
        '';

      const params = new URLSearchParams({
        q: searchTerm,
        type: 'product',
      });

      return `${this.searchUrl}?${params.toString()}`;
    },

    categoryMatches(device) {
      if (this.activeCategory === 'tablet') {
        return (
          device.category === 'tablet' ||
          device.category === 'e_reader'
        );
      }

      return device.category === this.activeCategory;
    },

    get filteredDevices() {
      const query = this.query
        .trim()
        .toLowerCase();

      const devices = this.devices.filter((device) => {
        if (!this.categoryMatches(device)) {
          return false;
        }

        if (!query) {
          return true;
        }

        const aliases = Array.isArray(device.aliases)
          ? device.aliases
          : [];

        return [
          device.name,
          device.brand,
          device.family,
          ...aliases,
        ]
          .filter(Boolean)
          .some((value) =>
            String(value)
              .toLowerCase()
              .includes(query)
          );
      });

      return devices.sort((a, b) => {
        const rank = (device) => {
          const result = this.fitResult(device);

          if (result === true) {
            return 0;
          }

          if (result === false) {
            return 1;
          }

          return 2;
        };

        return rank(a) - rank(b);
      });
    },

    fitResult(device) {
      const dimensions = device?.dimensions_mm;

      if (!dimensions) {
        return null;
      }

      const long = Number(
        dimensions.long_edge
      );

      const short = Number(
        dimensions.short_edge
      );

      const thickness = Number(
        dimensions.thickness
      );

      const {
        width,
        height,
        depth,
      } = this.bag;

      const values = [
        long,
        short,
        thickness,
        width,
        height,
        depth,
      ];

      if (
        !values.every(
          (value) =>
            Number.isFinite(value) &&
            value > 0
        )
      ) {
        return null;
      }

      const upright =
        long <= height &&
        short <= width &&
        thickness <= depth;

      const rotated =
        short <= height &&
        long <= width &&
        thickness <= depth;

      return upright || rotated;
    },

    fits(device) {
      return (
        this.fitResult(device) === true
      );
    },

    statusLabel(device) {
      const result =
        this.fitResult(device);

      if (result === true) {
        return this.labels.fits;
      }

      if (result === false) {
        return this.labels.doesntFit;
      }

      return this.labels.unknown;
    },

    statusClass(device) {
      const result =
        this.fitResult(device);

      if (result === true) {
        return 'bg-[#5f7f5b]';
      }

      if (result === false) {
        return 'bg-sg-red';
      }

      return 'bg-sg-grey-2';
    },
  }));
});